import { BOARDS_KEY_MAPPER_ENUM, PRICES_COLUMNS } from "@onesolution/constants";

export const pricesQueryParams = {
	boardId: BOARDS_KEY_MAPPER_ENUM.prices,
	columnIds: [PRICES_COLUMNS.name, PRICES_COLUMNS.prices],
	filter: [
		{
			column_id: PRICES_COLUMNS.availability,
			column_values: ["true"],
		},
	],
};
